import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-variants-fieldset',
    templateUrl: './variants-fieldset.component.html',
    styleUrls: ['./variants-fieldset.component.scss'],
    imports: [NgClass],
})
export class VariantsFieldsetComponent {
    @Input()
    public hasDeductible: boolean;
    @Input()
    public hasMonthlySettlementPeriod: boolean;
    @Input()
    public hasTheftCoverage: boolean;
    @Input()
    public boughtInLastTwoWeeks: boolean;
    @Input()
    public compactMode = false;

    @Output()
    public toggleDeductible: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output()
    public toggleSettlementPeriod: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output()
    public toggleTheftCoverage: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output()
    public toggleBoughtInLastTwoWeeks: EventEmitter<boolean> = new EventEmitter<boolean>();
}
